<div class="hero-carousel-skeleton" aria-label="Cargando contenido">
  <!-- Start::Skeleton para imagen -->
  <p-skeleton
    styleClass="hero-carousel-skeleton__main"
    animation="wave"
    borderRadius="0"
  />
  <!-- End::Skeleton para imagen -->

  <!-- Start::Skeleton de indicadores -->
  <div class="hero-carousel-skeleton__indicators" aria-hidden="true">
    @for(item of [1, 2, 3, 4, 5,6,7,8]; track $index) {
    <p-skeleton width="32px" height="8px" borderRadius="0" />
    }
  </div>
  <!-- End::Skeleton de indicadores -->
</div>
